
export const mockData = {
  code: 0,
  data: {
    allin_num: 104695,
    allin_win_rate: 4424,
    avatar_id: 0,
    first_hand_cards: [780, 267],
    first_login_date: '01/02 09:53',
    first_play_date: '2025/01/20',
    first_play_type: 'NLH',
    headimgurl: 'http://kkpoker-prod.s3.us-west-2.amazonaws.com/user_icon/headimage_knight.png',
    key: '6fd2d88c5c4e2f6edc6d4e52491fa916',
    kk_hand_num: 1,
    kk_win_num: 1,
    login_day_num: 119,
    login_time_part: 22,
    luck_lose_hand: 'A9s',
    luck_lose_rate: 58,
    luck_win_hand: '99',
    luck_win_rate: 88,
    max_play_date: '2025/06/24',
    max_play_hand_num: 18683,
    mtt_date: '2025/02/14',
    mtt_name: 'fastgame0213',
    mtt_rank: 1,
    mtt_reward: 9903600,
    nickname: 'MockUser',
    preferred_hand_num: 97307,
    preferred_type: 'MTT-NLH',
    rg_date: '2025/03/20',
    rg_pool_size: 19996,
    spinup_date: '2025/01/23',
    spinup_ratio: 1110,
    spinup_reward: 70000000,
    total_hand_num: 104709,
    total_hand_percent: 9905,
    uid: 1,
    version: 1
  }
};
